import React, { useState, useEffect } from "react";
import { getCatalogos, postData } from "../api/index";
import { Formik, Form, Field } from "formik";
import Cookies from "universal-cookie";
import { getCursosAsignados } from "../api/Paso1.api";
import { fetchApi } from "../../tools";
import { TextCombo } from "./subComponents/TextCombo";
import { useDepartamentosOptions } from "../../admisiones/custom-hooks";
// import PhoneInput from 'react-phone-number-input'
import { object, string } from "yup";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const Preinscripcion = ({
  urlCursos,
  state,
  send,
  setModal,
  headers,
  IdEmp,
}) => {
  const cookies = new Cookies();
  //const [url] = useState( cookies.get('__urlSchoolApi') )
  const urlSchool = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies

  const [departamentos] = useState([
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
  ]);
  const [showForm, setShowForm] = useState(false);
  const [deptoSeleccionado, setDeptoSeleccionado] = useState("01");
  const [btnContinuarText, setBtnContinuarText] = useState(
    "Guardar y continuar"
  );
  const [estado, setEstado] = useState("");
  const [dataCursos, setDataCursos] = useState();
  const options = useDepartamentosOptions(urlSchool, headers);

  const [countryCodeState, setCountryCodeState] = useState("gt");
  const [dialCodeState, setDialCodeState] = useState();

  const [IdProfesor, setIdProfesor] = useState(null);
  const [phonevalue, setPhonevalue] = useState();

  const initialValues = {
    Nombres: state.context.datosUsuario.Nombres,
    Apellidos: state.context.datosUsuario.Apellidos,
    Modalidad: state.context.datosUsuario.Modalidad || "", // estaba "2" si no tiene, le asigna presencial por defecto, mejor asignarlo pre si es nacional
    Email: state.context.datosUsuario.Email,
    Cel: state.context.datosUsuario.Cel,
    NIT: state.context.datosUsuario.NIT || "CF",
    NombreDoc: state.context.datosUsuario.NombreDoc,
    CodDepto: state.context.datosUsuario.CodDepto || "01",
  };

  const validationSchema = object({
    Email: string()
      .email("Ingrese un email válido")
      .required("Dato obligatorio"),
    Nombres: string()
      .max(200, "El nombre no debe exceder 200 letras")
      .required("Dato obligatorio"), // required
    Apellidos: string()
      .max(100, "El apellido no puede ser muy largo")
      .required("Dato obligatorio"),
    NIT: string(),
    NombreDoc: string().max(200, "El nombre no puede esceder a 200 caracteres"),
  });

  const validationSchemaCabecera = object({
    Email: string()
      .email("Ingrese un email válido")
      .required("Dato obligatorio"),
  });

  const fetchData = () => {
    if (state.context.seleccionados.length > 0) {
    } else {
      const catalogos = getCatalogos(
        urlCursos,
        send,
        headers,
        state.context?.datosUsuario?.Modalidad
      );
      send("CARGAR_CATALOGOS", { catalogos: catalogos.msg });
    }
  };

  const handleAssignData = async (
    e,
    values,
    errors,
    setFieldError,
    setFieldValue
  ) => {
    e.preventDefault();

    if (values.Cel.length < 5) {
      await setFieldError("Cel", "Dato obligatorio");
    } 
    if (values.Modalidad === 0) {
      await setFieldError("Modalidad", "Dato obligatorio");
    }

    if (countryCodeState !== "gt") { 
      await setFieldValue("CodDepto", "00");
      await setFieldValue("NombreDoc", "ext");
      await setFieldValue("NIT", "EXT");
      values.CodDepto = "00";
      values.NombreDoc = "ext";
      values.NIT = "EXT";
    } else {
      if (!departamentos.includes(values.CodDepto)) { 
        if (!deptoSeleccionado) {
          await setFieldError("CodDepto", "Dato obligatorio");
        } else {
          //values.CodDepto = "01" // le pone guatemala por si no elije departamento, deshabilitado por el momento
          values.CodDepto = deptoSeleccionado
          await setFieldValue("CodDepto", deptoSeleccionado);
        }
      } else {
      }
    }
    
    if (checkForErrors(values, setFieldError).every((elemento) => elemento)) {
      const sendData = async () => {
        send("GUARDAR_DATOS_USUARIO", { datosUsuario: values });
        if (Object.keys(errors).length > 0) {
          setModal({
            ok: false,
            show: true,
            msg: "Ingrese todos los datos por favor"//errors[Object.keys(errors)[0]], // "Se muestra mensaje que viene del validador del formik",
          });
        } else {
          if (estado === "NUEVO") {
            postData(
              IdEmp,
              urlCursos,
              send,
              values,
              headers,
              state,
              "NUEVO",
              state.context?.datosUsuario,
              { countryCode: countryCodeState, dialCode: dialCodeState }
            );
            // volver a enviar CAT_CURSOS para obtener los cursos con el filtro y CATALOGOS
            //getCatalogos(urlCursos, send, headers, values.Modalidad) // urlCursos, send, headers, modalidad
          } else {
            //send("IR_PASO2")
            postData(
              IdEmp,
              urlCursos,
              send,
              values,
              headers,
              dataCursos[0]["Id"],
              "",
              state.context?.datosUsuario,
              { countryCode: countryCodeState, dialCode: dialCodeState }
            );
            send("GUARDAR_IDSOLICITUD", { solicitud: dataCursos[0]["Id"] });
            send("GUARDAR_SEDE", {
              sede: dataCursos[0]?.Cursos[0]?.IdSede,
            });

            const catalogos = await getCatalogos(
              urlCursos,
              send,
              headers,
              state.context?.datosUsuario?.Modalidad
            );

            send("CARGAR_CATALOGOS", { catalogos: catalogos.msg });
          }
          if (state.context.solicitud !== "0") {
          } else {
            setModal({
              ok: false,
              show: true,
              msg: "No se pudo asignar un número de Id",
            });
          }
        }
      };
      
      if (values.Modalidad) { // if (values.Modalidad && values.Cel.length > 5) {
        if (countryCodeState !== "gt") {
          sendData();
        } else {
          if(values.CodDepto === " "){
            setModal({
              ok: false,
              show: true,
              msg: "Ingrese todos los datos por favor",
            });
          }else{
          if (!departamentos.includes(values.CodDepto)) {
            if (!deptoSeleccionado) {
              setModal({
                ok: false,
                show: true,
                msg: "Ingrese todos los datos por favor",
              });
              setFieldError("CodDepto", "Dato obligatorio");
            }
            setFieldValue("CodDepto", deptoSeleccionado);
            sendData(); // solo por prueba
          } else {
            sendData();
          }
        }
        }
      } else {
        setFieldError("Modalidad", "Dato obligatorio");
        setModal({
          ok: false,
          show: true,
          msg: "Ingrese todos los datos por favor",
        });
      }
    } else {
      // recorrer los que faltan y ponerles error
      checkForErrors(values, setFieldError)
      
      setModal({
        ok: false,
        show: true,
        msg: "Ingrese todos los datos por favor",
      });
   }
  };

  const checkForErrors = (values, setFieldError) => {
    let errors = []
    if(!values.Nombres){
      setFieldError("Nombres", "Dato obligatorio")
      errors.push(false)
    } 
    if(!values.Apellidos){
      setFieldError("Apellidos", "Dato obligatorio")
      errors.push(false)
    }
    if(values.Cel.length < 5) {
      setFieldError("Cel", "Dato obligatorio")
      errors.push(false)
    } 
    if(!values.NIT) {
      setFieldError("NIT", "Dato obligatorio")
      errors.push(false)
    }
    if(!values.NombreDoc) {
      setFieldError("NombreDoc", "Dato obligatorio")
      errors.push(false)
    }
    if(!values.CodDepto) {
      setFieldError("CodDepto", "Dato obligatorio")
      errors.push(false)
    }
    if(!values.Modalidad) {
      setFieldError("Modalidad", "Dato obligatorio")
      errors.push(false)
    }
    return errors
  }

  const limpiarForm = (setFieldValue) => {
    setFieldValue("Nombres", "");
    setFieldValue("Apellidos", "");
    setFieldValue("Cel", "");
    setFieldValue("NIT", "CF");
    setFieldValue("NombreDoc", "");
    setFieldValue("CodDepto", "");
    setFieldValue("Modalidad", 0);
    setPhonevalue("502");
    setCountryCodeState("gt");
  };

  const asignarValores = (setFieldValue, cursosAsignados) => {
    setCountryCodeState(() => cursosAsignados[0]["CountryCode"]);
    setDialCodeState(() => cursosAsignados[0]["DialCode"]);
    setPhonevalue(() => cursosAsignados[0]["Cel"]);
    setFieldValue("Cel", cursosAsignados[0]["Cel"]);
    setFieldValue("Email", cursosAsignados[0]["Email"]);
    setFieldValue("Nombres", cursosAsignados[0]["Nombres"]);
    setFieldValue("Apellidos", cursosAsignados[0]["Apellidos"]);
    //setFieldValue("Cel", phonevalue);
    setFieldValue("NIT", cursosAsignados[0]["NIT"]);
    setFieldValue("NombreDoc", cursosAsignados[0]["NombreDoc"]);
    setFieldValue(
      "Modalidad",
      cursosAsignados[0]["Cursos"][0]["Modalidad"] || ""
    );
    setFieldValue("CodDepto", cursosAsignados[0]["CodDepto"]);
  };

  const startPreinscripcion = async (e, values, errors, setFieldValue) => {
    e.preventDefault();

    const cursosAsignados = await getCursosAsignados(
      urlCursos,
      headers,
      values
    ); // si no existe, que me envie un response
    
    if(cursosAsignados[0].CountryCode !== "gt"){
      setFieldValue("Modalidad", "1")
    }else{
      setFieldValue("Modalidad", "")
    }
    values.CodDepto = cursosAsignados[0]["CodDepto"];
    setFieldValue("CodDepto", cursosAsignados[0]["CodDepto"]);

    send("GUARDAR_CURSOS_ANTES", { CursosAntes: cursosAsignados });
    // filtrar, si tiene el campo Cobrado pero es falso, se debe realizar el calculo del descuento aquí
    setDataCursos(() => cursosAsignados);
    const resProps = await fetchApi({
      url: urlCursos + "/inscripciones/propiedades_pagos",
      headers,
      content: {
        CanalPagos: 6,
      },
    });
    const formasPagoData = {
      Efectivo: resProps.msg[0].Efectivo,
      TC: resProps.msg[0].TC,
      CanalPagos: 6,
    };
    send("GUARDAR_FORMASPAGO", { formasp: formasPagoData }); // en el caso de enviar data, se setea el response mediante este metodo "SEND"
    setIdProfesor(cursosAsignados[0]["CodDepto"]);
    setDeptoSeleccionado(cursosAsignados[0]["CodDepto"]);
    
    if (cursosAsignados[0]?.Cursos?.length > 0) {
      // jalar y setear los headers aquí
      send("GUARDAR_DATOS_USUARIO", {
        datosUsuario: {
          IdSolicitud: cursosAsignados[0]["Id"],
          Apellidos: cursosAsignados[0]["Apellidos"],
          Cel: cursosAsignados[0]["Cel"],
          Email: cursosAsignados[0]["Email"],
          NIT: cursosAsignados[0]["NIT"],
          NombreDoc: cursosAsignados[0]["NombreDoc"],
          Nombres: cursosAsignados[0]["Nombres"],
          CodDepto: cursosAsignados[0]["CodDepto"],
          Modalidad: cursosAsignados[0]["Modalidad"]
        },
      });

      setPhonevalue(cursosAsignados[0]["Cel"]);
      // crear el header en esta línea
      let contador = 0;
      let toca = 0;

      cursosAsignados[0].Cursos.forEach((element, index) => {
        /* no hay response cuando el dato ingresado no tiene cursos
             y el id solicitud sí fue creado
          */
        contador = contador + 1;
        toca = 0;
        const header = {
          IdSede: element["IdSede"],
          IdCurso: element["IdCurso"],
          IdHorario: element["IdHorario"],
          IdPlan: element["IdPlan"],
          IdPeriodo: element["IdPeriodo"],
        };
        element["Cargos"][0]["Header"] = header;
        element.Cargos.forEach((cargo, indexCargo) => {
          contador = contador + 1;
          if (cargo.Cobrado === false) {
            toca = toca + 1;
          }
          cargo.IdSede = parseInt(element["IdSede"]); // quitar al momento de enviar para que lo guarde
          cargo.Key = element["IdHorario"];
          cargo.Index = element["IdHorario"];
          cargo.IdHorario = element["IdHorario"];
          cargo.sortIndex = contador;
          cargo.Seleccionado =
            toca === 1 || cargo.Cobrado === true ? true : false;
          cargo.Pagar = toca === 1 || cargo.Cobrado === true ? true : false;
          //cargo.Seleccionado = true;
          cargo.Asignado = true;
          cargo["Imagen"] = element.Imagen;
          // if(el.Cobrado)
        });
      });
      send("GUARDAR_CARNET", { carnet: cursosAsignados[0]["Carnet"] });
      send("RESET_SELECCIONADOS", { reset: [] });
      cursosAsignados[0].Cursos.forEach((curso) => {
        curso.Cargos.forEach((cargo, index) => {
          if (cargo.hasOwnProperty("Cobrado")) {
            if (!cargo.Cobrado) {
              cargo.Valor = cargo.Valor - cargo.Descuento;
              cargo.precioAnterior = cargo.Valor + cargo.Descuento;
            }
          }
          send("SELECCIONAR", { seleccionado: cargo }); //
        });
      });

      setShowForm(true);
      asignarValores(setFieldValue, cursosAsignados);
      setEstado(() => "CURSOS");
    }
    // CURSOS DATOS_USUARIO NUEVO
    if (!cursosAsignados[0]?.Cursos && !cursosAsignados[0]?.Error) {
      send("RESET_SELECCIONADOS", { reset: [] });
      try {
        asignarValores(setFieldValue, cursosAsignados);
        setShowForm(true);
      } catch (error) {
        setShowForm(true);
      }

      setEstado(() => "DATOS_USUARIO");
    }
    if (cursosAsignados[0]?.Error) {
      const datosVacios = {
        Apellidos: "",
        Cel: "",
        Email: "",
        NIT: "",
        NombreDoc: "",
        Nombres: "",
        Modalidad: null,
        CodDepto: "",
      };
      send("GUARDAR_DATOS_USUARIO", { datosUsuario: datosVacios });
      limpiarForm(setFieldValue);
      setShowForm(true);
      send("RESET_SELECCIONADOS", { reset: [] });
      setEstado(() => "NUEVO");
    }
  };
  const [infoGuate, setInfoGuate] = useState(true);

  const handleCel = async (e, country, setFieldValue, setFieldError) => {
    setCountryCodeState(country.countryCode);
    setDialCodeState(country.dialCode);

    setFieldValue("Cel", e);
    if (e.length < 5) {
      setFieldError("Cel", "Dato obligatorio");
    }

    if (dialCodeState === "502") {
      setInfoGuate(true);
    } else {
      setInfoGuate(false);
    }
  };

  const handleModalidad = (e, setFieldValue) => {
    setFieldValue("Modalidad", e.target.value);
    send("GUARDAR_MODALIDAD", { modalidad: e.target.value });
  };

  useEffect(() => {
    send("GUARDAR_HEADERS", { headers: headers });
    send("GUARDAR_IDEMP", { IdEmp: IdEmp });
    fetchData(); // funciona enviando la data con un useEffect, lo cual significa que se puede ejecutar cualquier función sin intervención de los servicios

    function handlePress(event) {
      if (
        document.activeElement.type === "number" ||
        document.activeElement.name === "Cel"
      ) {
        if (!`${event.target.value}${event.key}`.match(/^[0-9]*$/)) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }
    }
    window.addEventListener("keypress", handlePress);
    return () => {
      window.removeEventListener("keypress", handlePress);
    };
  }, []);

  useEffect(() => {
    if (dialCodeState === "502") {
      setInfoGuate(true);
    } else {
      setInfoGuate(false);
    }
  }, [dialCodeState]);

  const handleDepartamento = (setFieldValue, value) => {
    setFieldValue("CodDepto", value?.Codigo);
  };

  const handleNITBlur = (value, setFieldValue) => {
    if (countryCodeState === "gt") {
      if (!value) {
        setFieldValue("NIT", "CF");
      }
    }
  };
  const handleCelBlur = (value, setFieldError) => {
    if (value.Cel.length <= 5) {
      setFieldError("Cel", "Dato obligatorio");
    }
  };
  //handleNombreDocBlur
  const handleNombreDocBlur = (value, setFieldError) => {
    if (!value) {
      setFieldError("NombreDoc", "Dato obligatorio");
    }
  };

  const handleDepartamentoClick = () => {
    setIdProfesor("");
  };

  useEffect(() => {
    function handlePress(event) {
      if (document.activeElement.type === "number") {
        if (!`${event.target.value}${event.key}`.match(/^[0-9]*$/)) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }

      if (document.activeElement.type === "text") {
        if (
          !`${event.target.value}${event.key}`.match(
            /^[A-Z|ÁÉÍÓÚ|a-z|áéíóú|\s]*$/
          )
        ) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }
    }
    window.addEventListener("keypress", handlePress);
    return () => {
      window.removeEventListener("keypress", handlePress);
    };
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={showForm ? validationSchema : validationSchemaCabecera}
      // onSubmit={(values) => handleSubmit(values)}
    >
      {({
        setFieldValue,
        values,
        resetForm,
        errors,
        setValues,
        touched,
        setFieldError,
      }) => {
        return (
          <Form>
            <div className="shadow shadow-white">
              <div className={"grid content-center"}>
                <p className={"text-white mx-auto font-medium text-2xl my-2"}>
                  Preinscripción
                </p>
              </div>

              <div className="flex flex-row w-full">
                <div className="flex w-full  xl:w-1/2 mx-auto flex-col">
                  <div className=" sm:grid lg:flex flex-row gap-4 mb-4 bg-primarioMira p-2 |rounded-md w-full justify-center rounded-md ">
                    <div className="text-secundario w-full /md:w-1/2">
                      <p className="text-white font-medium">
                        PARA INICIAR EL PROCESO DEBES SELECCIONAR LOS SIGUIENTES
                        DATOS
                      </p>
                      <p className="text-gray-400 font-bold mt-2">
                        NOTA IMPORTANTE:
                      </p>
                      <p className="text-gray-400 text-justify">
                        Tener en cuenta que debes elegir cuidadosamente cada
                        curso individualmente. Asimismo, es necesario realizar
                        el pago correspondiente para garantizar la asignación
                        exitosa del curso seleccionado.
                      </p>
                    </div>

                    <div className="flex  flex-col md:flex-col justify-center w-full /sm:w-1/2">
                      <div className="flex flex-col md:flex-col"></div>
                      <div
                        className={
                          "w-full /sm:w-1/2 flex justify-center flex-col md:flex-col"
                        }
                      >
                        <p className={"text-secundario"}>
                          Ingrese correctamente su correo electrónico
                        </p>
                      </div>

                      <div className={"gap-2 hidden"}>
                        <p htmlFor="DPI" className="text-white">
                          DPI
                        </p>
                        <Field
                          name="DPI"
                          type="number"
                          value=""
                          minLength="0"
                          maxLength="13"
                          className="rounded-md w-full"
                          placeholder="0000000000000"
                          //onBlur={(e) => handleDpiBlur(e, errors, setFieldError)}
                        ></Field>
                      </div>

                      <p htmlFor="Email" className="text-white"></p>
                      <Field
                        name="Email"
                        type="email"
                        //disabled={!isValidDPI}
                        className="rounded-md w-full"
                        placeholder="tucorreo@ejemplo.com"
                      ></Field>
                      {errors.Email && (
                        <p className={"text-secundario"}>{errors.Email}</p>
                      )}

                      {/*<TextCombo data={data}/>*/}

                      <p htmlFor="" className="text-primarioMira">
                        Buscar
                      </p>
                      {
                        // values.DPI &&
                        values.Email ? (
                          <Field
                            as="button"
                            //disabled={!isValidDPI}
                            className={
                              "p-2 text-white bg-azulBrillanteMira rounded-md"
                            }
                            onClick={(e) =>
                              startPreinscripcion(
                                e,
                                values,
                                errors,
                                setFieldValue
                              )
                            }
                          >
                            Buscar
                          </Field>
                        ) : null
                      }
                    </div>
                  </div>
                </div>
              </div>

              {showForm && (
                <div
                  className={
                    "w-full mx-auto xl:w-1/2 bg-primarioMira rounded-md md:p-2 p-1 md: m-2"
                  }
                >
                  <div className="grid grid-rows-1 grid-flow-col w-full">
                    <div className="flex flex-col">
                      <div className="elementFadeIn">
                        {!values.Nombres && (
                          <p className={"text-secundario"}>
                            Usuario no registrado, por favor llenar los
                            siguientes datos.
                          </p>
                        )}
                        <div className="flex flex-col md:flex-col gap-4">
                          <div className="flex flex-col /lg:w-1/2">
                            <p htmlFor="Nombres" className="text-white">
                              Nombres
                            </p>
                            <Field
                              name="Nombres"
                              type="text"
                              className="rounded-md w-full"
                            ></Field>
                            {errors.Nombres && (
                              <p className="text-secundario">
                                {errors.Nombres}
                              </p>
                            )}
                          </div>
                          <div className="flex flex-col /lg:w-1/2">
                            <p htmlFor="Apellidos" className="text-white">
                              Apellidos
                            </p>
                            <Field
                              name="Apellidos"
                              type="text"
                              className="rounded-md w-full"
                            ></Field>
                            {errors.Apellidos && (
                              <p className="text-secundario">
                                {errors.Apellidos}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="flex flex-col /lg:w-1/2 my-2">
                          <p htmlFor="Cel" className="text-white">
                            Celular
                          </p>
                          <PhoneInput
                            country={countryCodeState}
                            value={phonevalue}
                            //onBlur={() => handleCelBlur(values, setFieldError)}
                            onChange={(e, country) =>
                              handleCel(
                                e,
                                country,
                                setFieldValue,
                                setFieldError
                              )
                            }
                          />
                          {errors.Cel && (
                            <p className="text-secundario">{errors.Cel}</p>
                          )}
                        </div>

                        <div className="flex flex-col md:flex-col gap-4">
                          {infoGuate && (
                            <div className="elementFadeIn">
                              <div className="flex flex-col /lg:w-1/2">
                                <p htmlFor="NIT" className="text-white">
                                  NIT
                                </p>
                                <Field
                                  name="NIT"
                                  type="search"
                                  className="rounded-md w-full"
                                  onBlur={() =>
                                    handleNITBlur(values.NIT, setFieldValue)
                                  }
                                ></Field>
                                {errors.NIT && (
                                  <p className="text-secundario">
                                    {errors.NIT}
                                  </p>
                                )}
                              </div>
                              <div className="flex flex-col /lg:w-1/2">
                                <p htmlFor="NombreDoc" className="text-white">
                                  Nombre de emisión de recibo
                                </p>
                                <Field
                                  name="NombreDoc"
                                  type="text"
                                  className="rounded-md w-full"
                                  onBlur={() =>
                                    handleNombreDocBlur(
                                      values.NombreDoc,
                                      setFieldError
                                    )
                                  }
                                ></Field>
                                {errors.NombreDoc && (
                                  <p className="text-secundario">
                                    {errors.NombreDoc}
                                  </p>
                                )}
                              </div>
                              <TextCombo
                                departamentos={departamentos}
                                title="Departamento"
                                data={options.departamentos_ins}
                                value={IdProfesor} // IdProfesor.Departamento
                                id={"Codigo"}
                                setSelected={setIdProfesor}
                                setFieldValue={setFieldValue}
                                setFieldError={setFieldError}
                                handleDepartamento={handleDepartamento}
                                handleClick={handleDepartamentoClick}
                                //defaultValue={IdProfesor["Codigo"]}
                              />
                              {errors.CodDepto && (
                                <p className="text-secundario ">
                                  {errors.CodDepto}
                                </p>
                              )}
                            </div>
                          )}
                        </div>

                        <div className="w-full flex justify-between mt-4">
                          <div className="flex /flex-row w-full lg:w-2/4 /bg-red-200  flex-col">
                            <p className="text-white my-auto mr-2">Modalidad</p>
                            <div className="flex w-full flex-row p-1 lg:p-1 justify-between ring-grisMira ring-1 rounded-md ">
                              <div className="p-1 flex flex-row my-auto">
                                <p
                                  htmlFor="Modalidad"
                                  className="text-white text-md"
                                >
                                  Online
                                </p>
                                <Field
                                  type="radio"
                                  className="ml-1 mr-2 text-salmon cursor-pointer my-auto"
                                  value={1}
                                  name="Modalidad"
                                  onChange={(e) =>
                                    handleModalidad(e, setFieldValue)
                                  }
                                  checked={values?.Modalidad == 1}
                                ></Field>
                              </div>
                              <div className="p-1 flex flex-row my-auto">
                                <p
                                  htmlFor="Modalidad"
                                  className="text-white text-md"
                                >
                                  Presencial
                                </p>
                                <Field
                                  type="radio"
                                  className="ml-1 mr-2 text-salmon cursor-pointer my-auto"
                                  value={2}
                                  name="Modalidad"
                                  onChange={(e) =>
                                    handleModalidad(e, setFieldValue)
                                  }
                                  checked={values?.Modalidad == 2}
                                ></Field>
                              </div>
                              <div className="p-1 flex flex-row my-auto">
                                <p
                                  htmlFor="Modalidad"
                                  className="text-white text-md"
                                >
                                  Empresarial
                                </p>
                                <Field
                                  type="radio"
                                  className="ml-1 mr-2 text-salmon cursor-pointer my-auto"
                                  value={3}
                                  name="Modalidad"
                                  onChange={(e) =>
                                    handleModalidad(e, setFieldValue)
                                  }
                                  checked={values?.Modalidad == 3}
                                ></Field>
                              </div>
                            </div>
                            {errors.Modalidad && (
                              <p className="text-secundario ">
                                {errors.Modalidad}
                              </p>
                            )}
                          </div>

                          <div className="inline my-auto">
                            <button
                              name="cmdSave"
                              type="reset"
                              className="rounded-md bg-azulBrillanteMira inline text-white p-2 m-2"
                              onClick={(e) =>
                                handleAssignData(
                                  e,
                                  values,
                                  errors,
                                  setFieldError,
                                  setFieldValue
                                )
                              }
                            >
                              {btnContinuarText}
                            </button>
                          </div>
                        </div>

                        <div className="flex flex-row justify-center">
                          {/*
                        <button 
                        name="cmdClean" 
                        type="button" 
                        className="rounded-md bg-azulBrillanteMira inline text-white p-2"
                        onClick={(e) => handleCleanForm(e, errors)} >Limpiar</button>
                      */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Preinscripcion;
